import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const Posts = () => {
  const [post, setPost] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    const fetchData = async () => {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/allposts`, {
        method: "GET",
        headers: {
          Accept: "application/json",
        },
      })
        .then((res) => {
          return res.json();
        })
        .then((data) => {
          if (data) {
            setPost(data.posts);
            setLoading(false);
          } else {
            console.log("err");
          }
        });
    };
    fetchData();
  }, []);

  return (
    <div className="container">
      <h2 className="text-white font-weight-bold border-bottom">
        LATEST POSTS
      </h2>
      {loading && <p className="text-white">Loading...</p>}
      {!loading && (
        <>
          {post
            .map((posts) => (
              <div key={posts._id}>
                <br />
                <div className="card">
                  <img
                    className="card-img-top"
                    src={`${process.env.REACT_APP_AWS}/${posts.photo}`}
                    alt={posts.title}
                  />

                  <div className="card-body">
                    <i className="fas fa-clock"></i>{" "}
                    {new Date(posts.created).toDateString()}
                    <h5 className="card-title">{posts.title}</h5>
                    <p className="card-text">{posts.content}</p>
                    <p className="card-text">
                      <a
                        href={`${posts.link}`}
                        className="btn btn-raised btn-primary"
                        target="_blank"
                      >
                        <i className="fas fa-link"></i> enroll
                      </a>{" "}
                      <br />
                    </p>
                  </div>
                </div>
              </div>
            ))
            .reverse()}
        </>
      )}
    </div>
  );
};

export default Posts;
